import { useState, useEffect } from "react"
import { Card, CardContent, Typography, Chip, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Collapse, Grid, IconButton, DialogTitle, Dialog, DialogContent, DialogActions, Box, Tooltip, } from "@mui/material"
import { ExpandMore, ExpandLess, CheckCircle, Cancel, CalendarToday, Sync } from "@mui/icons-material"
import { warningNotification } from "utils/toastify"
import ConsultaRucService from "services/ConsultaIdentificacion/ConsultaRucServices"
import { GridCheckCircleIcon, GridCloseIcon } from "@mui/x-data-grid"
import ModalSyncRuc from "./ModalSyncRuc"

const RucResults = (props) => {
    const [showEstablecimientos, setShowEstablecimientos] = useState(false)
    const [proveedor, setProveedor] = useState({})
    const [representante, setRepresentante] = useState({})
    const [listaEstablecimiento, setListaEstablecimiento] = useState([])
    const [loadingSync, setLoadingSync] = useState(false);
    const [syncAction, setSyncAction] = useState(false);

    useEffect(() => {

        if (!props.data?.ruc)
            return

        if (props.data?.ruc.length < 13 || props.data?.ruc.length > 13) {
            props.setLoading(false);
            warningNotification("El número de RUC debe tener exactamente 13 dígitos.");
            return
        }

        let isMounted = true;

        setProveedor({});
        setRepresentante({});
        setListaEstablecimiento([]);

        ConsultaRucService.Get(props.data).then(async (result) => {
            props.setLoading(false)
            const { code, payload, message } = result;
            if (isMounted) {
                if (code === '1') {
                    const data = (result.payload) ? JSON.parse(result.payload) : [];
                    if (data) {
                        const { proveedorData, representanteData, establecimientoData } = data;
                        setProveedor((proveedorData) ? proveedorData : {});
                        setRepresentante((representanteData) ? representanteData : []);
                        setListaEstablecimiento((establecimientoData) ? establecimientoData : []);
                        props.setResult(true)
                    }
                } else {
                    resetModalSync();
                    // warningNotification(message);
                }
            }
        })
            .catch((e) => {
                props.setLoading(false)
                console.log(e.message);
            });
        return () => {
            isMounted = false;
        };
    }, [props.data]);

    const getStatusColor = (estado) => {
        switch (estado) {
            case "ACTIVO":
            case "ABIERTO":
                return "success"
            case "INACTIVO":
            case "CERRADO":
                return "error"
            case "SUSPENDIDO":
                return "warning"
            default:
                return "default"
        }
    }

    const getStatusIcon = (estado) => {
        switch (estado) {
            case "ACTIVO":
            case "ABIERTO":
                return <CheckCircle sx={{ fontSize: 16 }} />
            case "INACTIVO":
            case "CERRADO":
            case "SUSPENDIDO":
                return <Cancel sx={{ fontSize: 16 }} />
            default:
                return null
        }
    }

    const resetForm = () => {
        props.setRuc({})
        setProveedor({});
        setRepresentante({});
        setListaEstablecimiento([]);
        setShowEstablecimientos(false);
        setLoadingSync(false);
        setSyncAction(false)
        props.reset({ ruc: "" })
        props.setResult(false)
    }

    const establecimientoMatriz = (listaEstablecimiento.length > 1) ? listaEstablecimiento.find((e) => e.matriz === "SI") : listaEstablecimiento[0];

    const establecimientosAdicionales = (listaEstablecimiento.length > 1) ? listaEstablecimiento.filter((e) => e.matriz === "NO") : [];

    const handleSync = async () => {

        setLoadingSync(true);

        let isMounted = true;

        ConsultaRucService.GetSync(props.data).then(async (result) => {
            setLoadingSync(false);
            const { code, payload, message } = result;
            if (isMounted) {
                if (code === '1') {
                    const data = (result.payload) ? JSON.parse(result.payload) : [];
                    if (data) {
                        const { proveedorData, representanteData, establecimientoData } = data;
                        setProveedor((proveedorData) ? proveedorData : {});
                        setRepresentante((representanteData) ? representanteData : []);
                        setListaEstablecimiento((establecimientoData) ? establecimientoData : []);
                        props.setResult(true);
                        setSyncAction(false);
                        setLoadingSync(false);
                    }
                } else {
                    setSyncAction(false)
                    setLoadingSync(false);
                    warningNotification(message);
                }
            }
        })
            .catch((e) => {
                setSyncAction(false)
                setLoadingSync(false)
                console.log(e.message);
            });
        return () => {
            isMounted = false;
        };
    };

    const resetModalSync = () => {
        setLoadingSync(false);
        setSyncAction(true);
    }

    return (
        <>
            <Dialog
                open={props.result}
                onClose={resetForm}
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="h4" component="span">
                        Información del Proveedor
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <IconButton onClick={resetForm}>
                            <GridCloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container item spacing={2}>
                        <Grid item xs={12}>
                            <Card sx={{ bgcolor: "#fff", border: "1px solid #e0e0e0", borderRadius: 2 }}>
                                <CardContent>
                                    <Grid container sx={{ p: 1, borderBottom: "1px solid #e0e0e0" }}>
                                        <Grid item lg={3} md={4} sm={12} xs={12} sx={{ display: "flex" }}  >
                                            <Grid>
                                                <Typography variant="h5" sx={{ color: "#616161" }}>RUC</Typography>
                                                <Typography variant="h4">{proveedor.numeroRuc}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item lg={6} md={4} sm={12} xs={12} sx={{ display: "flex" }}>
                                            <Grid>
                                                <Typography variant="h5" sx={{ color: "#616161" }}>Razón Social</Typography>
                                                <Typography variant="h4">{proveedor.razonSocial}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item lg={3} md={4} sm={12} xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                            <Paper
                                                elevation={2}
                                                sx={{
                                                    px: 2,
                                                    py: 0.5,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    borderRadius: 3,
                                                    backgroundColor: "#0d47a1",
                                                    gap: 1,
                                                }}
                                            >
                                                <Tooltip title="Sincronizar Datos con SRI">
                                                    <IconButton
                                                        size="small"
                                                        onClick={handleSync}
                                                        disabled={loadingSync}
                                                        sx={{
                                                            color: "white",
                                                            border: "1px solid #0d47a1",
                                                            "&:hover": {
                                                                backgroundColor: "rgba(13,71,161,0.08)",
                                                            },
                                                            "&.Mui-disabled": {
                                                                color: "rgba(255,255,255,0.6)",  // blanco más claro
                                                                backgroundColor: "#0d47a1",       // mantiene el azul institucional
                                                                borderColor: "#0d47a1",
                                                                opacity: 0.7,                  // da la sensación de deshabilitado                                                            
                                                            },
                                                            transition: "transform 0.3s ease",
                                                            "@keyframes spin": {
                                                                from: { transform: "rotate(0deg)" },
                                                                to: { transform: "rotate(360deg)" },
                                                            },
                                                        }}
                                                    >
                                                        <Sync fontSize="small" sx={{
                                                            animation: loadingSync ? "spin 1s linear infinite" : "none",
                                                        }} />
                                                    </IconButton>
                                                </Tooltip>
                                                <CalendarToday sx={{ color: "white", fontSize: 18 }} />
                                                <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{ color: "white", opacity: 0.8 }}
                                                    >
                                                        Fecha actualización SRI
                                                    </Typography>
                                                    <Typography
                                                        variant="body2"
                                                        fontWeight="bold"
                                                        sx={{ color: "white" }}
                                                    >
                                                        {proveedor.fechaConsultaSRI}
                                                    </Typography>
                                                </Box>
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                    <Grid container sx={{ p: 1, borderBottom: "1px solid #e0e0e0" }}>
                                        <Grid item lg={3} md={4} sm={6} xs={12} sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}  >
                                            <Typography variant="h5" sx={{ color: "#616161" }}>Estado contribuyente en el RUC</Typography>
                                            <Chip
                                                icon={getStatusIcon(proveedor.estadoContribuyenteRuc)}
                                                label={proveedor.estadoContribuyenteRuc}
                                                color={getStatusColor(proveedor.estadoContribuyenteRuc)}
                                                sx={{ fontWeight: 600 }}
                                            />
                                        </Grid>
                                        {
                                            representante && Object.keys(representante).length > 0 &&
                                            <Grid item lg={5} md={8} sm={6} xs={12} sx={{ border: "1px solid #616161", borderRadius: 1, padding: 2, display: "flex", flexDirection: "column", gap: 1, }}>
                                                <Typography
                                                    variant="h5"
                                                    sx={{
                                                        fontWeight: 600,
                                                        textAlign: "center"
                                                    }}
                                                >
                                                    Representante legal
                                                </Typography>

                                                <Typography variant="h5">
                                                    <strong>Nombre/Razón Social: </strong> {representante?.razonSocial ?? ""}
                                                </Typography>

                                                <Typography variant="h5">
                                                    <strong>Identificación: </strong> {representante?.numeroIdentificacion}
                                                </Typography>
                                            </Grid>

                                        }
                                    </Grid>
                                    <Grid container sx={{ p: 1 }}>
                                        <Grid item lg={3} md={4} sm={12} xs={12}>
                                            <Typography variant="h5">
                                                <strong>Contribuyente fantasma: </strong> {proveedor.contribuyenteFantasma}
                                            </Typography>
                                        </Grid>
                                        <Grid item lg={5} md={4} sm={12} xs={12}>
                                            <Typography variant="h5">
                                                <strong>Contribuyente con transacciones inexistentes: </strong> {proveedor.transaccionesInexistente}
                                            </Typography>
                                        </Grid>
                                        <Grid item lg={4} md={4} sm={12} xs={12}>
                                            <Typography variant="h5">
                                                <strong>Gran Contribuyente: </strong> {proveedor?.granContribuyente}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    {/* <Grid container sx={{ p: 2, alignItems: "center" }}> */}
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                        <TableContainer sx={{ maxHeight: 600 }}>
                                            <Table>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell sx={{ bgcolor: "#0d47a1", color: "white", textAlign: "center", width: "25%" }}>
                                                            <Typography variant="h5" color="white">
                                                                Actividad económica principal
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell sx={{ width: "75%" }} align="center">
                                                            <Typography variant="body1">
                                                                {proveedor.actividadEconomicaPrincipal}
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12} mt={1}>
                                        <TableContainer sx={{ maxHeight: 600 }}>
                                            <Table aria-label="sticky table" size="small">
                                                <TableHead sx={{ bgcolor: "#0d47a1" }}>
                                                    <TableRow>
                                                        <TableCell align="center" sx={{ color: "white", fontWeight: 600 }}>Tipo contribuyente</TableCell>
                                                        <TableCell align="center" sx={{ color: "white", fontWeight: 600 }}>Régimen</TableCell>
                                                        <TableCell align="center" sx={{ color: "white", fontWeight: 600 }}>Categoría</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell align="center">
                                                            {proveedor.tipoContribuyente}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {proveedor.regimen}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {proveedor.categoria}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12} mt={1}>
                                        <TableContainer sx={{ maxHeight: 600 }}>
                                            <Table aria-label="sticky table" size="small">
                                                <TableHead sx={{ bgcolor: "#0d47a1" }}>
                                                    <TableRow>
                                                        <TableCell align="center" sx={{ color: "white", fontWeight: 600 }}>Obligado a llevar contabilidad</TableCell>
                                                        <TableCell align="center" sx={{ color: "white", fontWeight: 600 }}>Agente de retención	</TableCell>
                                                        <TableCell align="center" sx={{ color: "white", fontWeight: 600 }}>Contribuyente especial</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell align="center">
                                                            {proveedor.obligadoLlevarContabilidad}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {proveedor.agenteRetencion}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {proveedor.contribuyenteEspecial}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12} mt={1}>
                                        <TableContainer sx={{ maxHeight: 600 }}>
                                            <Table aria-label="sticky table" size="small">
                                                <TableHead sx={{ bgcolor: "#0d47a1" }}>
                                                    <TableRow>
                                                        <TableCell align="center" sx={{ color: "white", fontWeight: 600 }}>Fecha inicio actividades</TableCell>
                                                        <TableCell align="center" sx={{ color: "white", fontWeight: 600 }}>Fecha actualización</TableCell>
                                                        <TableCell align="center" sx={{ color: "white", fontWeight: 600 }}>Fecha cese actividades</TableCell>
                                                        <TableCell align="center" sx={{ color: "white", fontWeight: 600 }}>Fecha reinicio actividades</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell align="center">
                                                            {proveedor.fechaInicioActividades}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {proveedor.fechaActualizacion}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {proveedor.fechaCese}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {proveedor.fechaReinicioActividades}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                    {/* </Grid> */}
                                    <Grid container spacing={2} sx={{ mb: 8 }}>
                                        {/* Establecimientos */}
                                        <Grid item xs={12} mt={2}>
                                            <Grid container justifyContent="flex-end" alignItems="center">
                                                <Grid item>
                                                    <Button
                                                        variant="outlined"
                                                        onClick={() => setShowEstablecimientos(!showEstablecimientos)}
                                                        endIcon={showEstablecimientos ? <ExpandLess /> : <ExpandMore />}
                                                        sx={{
                                                            borderColor: "black",
                                                            bgcolor: "black",
                                                            color: "white",
                                                            fontWeight: 600,
                                                            px: 2,
                                                            py: 1,
                                                            "&:hover": {
                                                                bgcolor: "#3f3e3eff",
                                                            },
                                                        }}
                                                    >
                                                        {showEstablecimientos ? "Ocultar establecimientos" : "Mostrar establecimientos"}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                            <Collapse in={showEstablecimientos}>
                                                {/* Matriz */}
                                                {establecimientoMatriz && (
                                                    <Grid item xs={12} sx={{ mt: 2 }}>
                                                        <Typography variant="h4" sx={{ mb: 2 }}>
                                                            Establecimiento Matriz
                                                        </Typography>
                                                        <TableContainer component={Paper}>
                                                            <Table>
                                                                <TableHead sx={{ bgcolor: "#0d47a1" }}>
                                                                    <TableRow>
                                                                        <TableCell sx={{ color: "white", fontWeight: 600 }}>No. establecimiento</TableCell>
                                                                        <TableCell sx={{ color: "white", fontWeight: 600 }}>Nombre Comercial</TableCell>
                                                                        <TableCell sx={{ color: "white", fontWeight: 600 }}>Ubicación de establecimiento</TableCell>
                                                                        <TableCell sx={{ color: "white", fontWeight: 600 }}>Estado del establecimiento</TableCell>
                                                                        {/* <TableCell sx={{ color: "white", fontWeight: 600 }}>Fecha Apertura</TableCell> */}
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    <TableRow hover>
                                                                        <TableCell sx={{ fontFamily: "monospace", fontWeight: 600 }}>{establecimientoMatriz.establecimiento}</TableCell>
                                                                        <TableCell sx={{ fontWeight: 600 }}>
                                                                            {establecimientoMatriz.nombreComercial || proveedor.razonSocial}
                                                                        </TableCell>
                                                                        <TableCell sx={{ maxWidth: 300 }}>
                                                                            {establecimientoMatriz.direccion}
                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            <Chip
                                                                                icon={getStatusIcon(establecimientoMatriz.estado)}
                                                                                label={establecimientoMatriz.estado}
                                                                                color={getStatusColor(establecimientoMatriz.estado)}
                                                                                size="small"
                                                                                sx={{ fontWeight: 600 }}
                                                                            />
                                                                        </TableCell>
                                                                        {/* <TableCell sx={{ fontWeight: 600 }}>
                                                                        {establecimientoMatriz.fechaApertura}
                                                                    </TableCell> */}
                                                                    </TableRow>
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                )}
                                                {establecimientosAdicionales.length > 0 && (
                                                    <Grid item xs={12} sx={{ mt: 2 }}>
                                                        <Typography variant="h4" sx={{ mb: 2 }}>
                                                            {establecimientoMatriz && "Establecimientos Adicionales"}
                                                            {!establecimientoMatriz && "Establecimientos"}
                                                        </Typography>
                                                        <TableContainer component={Paper}>
                                                            <Table>
                                                                <TableHead sx={{ bgcolor: "#0d47a1" }}>
                                                                    <TableRow>
                                                                        <TableCell sx={{ color: "white", fontWeight: 600 }}>No. establecimiento</TableCell>
                                                                        <TableCell sx={{ color: "white", fontWeight: 600 }}>Nombre Comercial</TableCell>
                                                                        <TableCell sx={{ color: "white", fontWeight: 600 }}>Ubicación de establecimiento</TableCell>
                                                                        <TableCell sx={{ color: "white", fontWeight: 600 }}>Estado del establecimiento</TableCell>
                                                                        {/* <TableCell sx={{ color: "white", fontWeight: 600 }}>Fecha Apertura</TableCell> */}
                                                                        {/* <TableCell sx={{ color: "white", fontWeight: 600 }}>Contacto</TableCell> */}
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {establecimientosAdicionales.map((est) => (
                                                                        <TableRow hover key={est.establecimiento}>
                                                                            <TableCell sx={{ fontFamily: "monospace", fontWeight: 600 }}>{est.establecimiento}</TableCell>
                                                                            <TableCell sx={{ fontWeight: 600 }}>
                                                                                {est.nombreComercial || proveedor.razonSocial}
                                                                            </TableCell>
                                                                            <TableCell sx={{ maxWidth: 300 }}>
                                                                                {est.direccion}
                                                                            </TableCell>
                                                                            <TableCell align="center">
                                                                                <Chip
                                                                                    icon={getStatusIcon(est.estado)}
                                                                                    label={est.estado}
                                                                                    color={getStatusColor(est.estado)}
                                                                                    size="small"
                                                                                    sx={{ fontWeight: 600 }}
                                                                                />
                                                                            </TableCell>
                                                                            {/* <TableCell sx={{ fontWeight: 600 }}>
                                                                            {est.fechaApertura}
                                                                        </TableCell> */}
                                                                            {/* <TableCell>
                                                                    {
                                                                        est.telefono &&
                                                                        <Typography variant="caption">
                                                                            Tel: {est.telefono}
                                                                        </Typography>
                                                                    }
                                                                    {
                                                                        est.email &&
                                                                        <Typography variant="caption">
                                                                            Email: {est.email}
                                                                        </Typography>
                                                                    }
                                                                </TableCell> */}
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                )}
                                            </Collapse>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "flex-end" }}>
                    <Button
                        onClick={resetForm}
                        variant="outlined"
                        color="primary"
                    >
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>

            <ModalSyncRuc
                open={syncAction}
                setSyncAction={setSyncAction}
                onConfirm={handleSync}
                setLoadingSync={setLoadingSync}
                loadingSync={loadingSync}
            />
        </>
    )
}

export default RucResults
